<template>
  <Modal
    v-bind="getBindValue"
    ref="modal"
    :keyboard="keyboard"
    :open="open"
    :wrap-class-name="`${bem.b()} ${wrapClassName} ${currentClass}`"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <template v-if="$slots['closeIcon']" #closeIcon>
      <slot name="closeIcon" />
    </template>

    <!-- 头部区域 -->
    <template #title>
      <slot name="title">
        <span>{{ title }}</span>
      </slot>
    </template>
    <!-- 内容区域 -->
    <div ref="scrollRef" :class="[bem.e('container')]">
      <slot />
    </div>
    <!-- 底部区域 -->
    <template v-if="showFooter" #footer>
      <div
        :class="`${bem.e('footer')} ${
          isShowContentBottomBox ? bem.e('footer-shadow') : ''
        }`"
      >
        <slot name="footer">
          <ll-button
            v-if="type !== 'confirm'"
            :label="cancelText"
            size="middle"
            v-bind="cancelButtonProps"
            @click="handleCancel"
          >
          </ll-button>
          <ll-button
            type="primary"
            :loading="props.confirmLoading"
            size="middle"
            :label="
              props.confirmText
                ? props.confirmText
                : props.type === 'confirm'
                ? '知道了'
                : '确认'
            "
            v-bind="okButtonProps"
            @click="handleOk"
          />
        </slot>
      </div>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import { computed, ref, useAttrs } from 'vue'

import { LlButton } from '@ll-plus/components'
import { Modal } from 'ant-design-vue'

import { useScroll } from '@ll-plus/hooks'
import { createNamespace } from '@ll-plus/utils'
import { omit } from 'lodash-es'
import { newModalEmits, newModalProps } from './modal'

import type { ModalProps } from 'ant-design-vue'

defineOptions({ name: 'LlNewModal' })

// 1.props/emits
const props = defineProps(newModalProps)
const emits = defineEmits(newModalEmits)

// 2.hooks
const attrs = useAttrs()
const { scrollPosition, isHasScrollBar, scrollRef } = useScroll()

// 3.ref/computed/const
const modal = ref<HTMLElement>()

const currentClass = ref<string>('')
// const isShowContentBottomBox = ref(false)
const getBindValue = computed(() => {
  const result: ModalProps = {
    ...omit({ ...attrs }, [...Object.keys(newModalProps), 'wrapClassName']),
  }
  if (!props.showFooter) result.footer = null
  return result
})
// 是否显示底部的阴影
const isShowContentBottomBox = computed(() => {
  // 如果顶部的阴影为true则说明是内部的容器在滚动产品的阴影 则由容器的滚动情况来决定阴影
  if (props.footerShadowPlacement === 'inner') {
    return (
      props.isShowFooterShadow &&
      isHasScrollBar.value &&
      scrollPosition.value !== 'bottom'
    )
  } else {
    // 如果顶部的阴影为false，则说明不是内部容器滚动，则底部的阴影由 外部的isShowFooterShadow来决定
    return props.isShowFooterShadow
  }
})
const bem = createNamespace('new-modal')

// 3.methods
const handleCancel = () => {
  emits('cancel')
  emits('update:open')
}
const handleOk = () => {
  emits('ok')
}
// 滚动条返回顶部
const scrollTop = () => {
  if (scrollRef && scrollRef.value) {
    scrollRef.value.scrollTop = 0
    scrollPosition.value = 'top'
  }
}

// 4.defineExpose
defineExpose({
  scrollTop,
})
</script>
